export class MissingAPIDialectError extends Error {
  constructor() {
    super('API Dialect not specified');
  }
}
